export default "__VITE_ASSET__C_ruoz$m__"